<template>
  <div class="more">
    <!-- <van-nav-bar left-arrow title="全部课程" @click-left="onClickLeft" /> -->
    <div class="page">
      <!-- 轮播图 -->
      <div class="wrapper">
        <swiper
          style="width: 90%; height: 100%"
          :options="swiperOption"
          ref="mySwiper"
        >
          <swiper-slide v-for="item of swiperList" :key="item.id">
            <img class="swiper-img" :src="item.imgUrl" />
          </swiper-slide>
          <div class="swiper-pagination" slot="pagination"></div>
        </swiper>
      </div>
      <categoryTab></categoryTab>
      <!-- 底部 -->
    <div style="height: 150px; width: auto;"></div>
    </div>
  </div>
</template>

<script>
import wx from "weixin-js-sdk";
// import tabZujian from '@/components/tabZujian'
import categoryTab from '@/components/categoryTab'
export default {
  name: "more",
  components:{
    categoryTab:categoryTab
  },
  data() {
    return {
      swiperOption: {
        pagination: ".swiper-pagination",
        //修改分页器样式 ,
        bulletClass: "my-swiper-pagination-bullet",
        //激活样式
        bulletActiveClass: "my-bullet-active",
        //属性设置 自动轮播
        autoplay: true,
        speed: 2000,
        setWrapperSize: true,
        autoHeight: true,
        paginationClickable: true,
        mousewheelControl: true,
        observeParents: true,
        loop: true,
      },
      swiperList: [
        {
          id: "0001",
          imgUrl:
            "https://ss1.bdstatic.com/70cFuXSh_Q1YnxGkpoWK1HF6hhy/it/u=2101839000,1415175059&fm=26&gp=0.jpg",
        },
        {
          id: "0002",
          imgUrl:
            "https://ss1.bdstatic.com/70cFuXSh_Q1YnxGkpoWK1HF6hhy/it/u=2101839000,1415175059&fm=26&gp=0.jpg",
        },
        {
          id: "0003",
          imgUrl:
            "https://ss1.bdstatic.com/70cFuXSh_Q1YnxGkpoWK1HF6hhy/it/u=2101839000,1415175059&fm=26&gp=0.jpg",
        },
      ],
    };
  },
  methods:{
    onClickLeft() {
      this.$router.go(-1);
    },
  }
};
</script>


<style lang="css" >
 html,body,#app{
    background-color: #eae8e8;
  }
.more{
  background-color: #EAE8E8;
  height:auto;
}
.page{
  background-color: #EAE8E8;
}
.page .el-tabs__active-bar{
  /* background: #C8291C; */
  top :65px;
  left:25px;
  /* width: 30px; */
  /* top: 50px; */
}
.page .el-tabs__header{
  height: 80px;
  width: auto;
}
.page .el-tabs__nav-scroll{
  width: 90%; 
  left: 30px;
  /* display: flex; */
  /* bottom: 2px; */
   height: 70px;
}
.page .el-tabs__item{
    font-size: 39px;
    left: 25px;
    padding-right:36px;
}
.page .el-tabs__item{
  font-size: 35px;
}
.page .el-tabs__content{
  height:auto;
}
.page .el-tabs__nav-wrap::after{
  background-color: #d4d4d4;
}
.van-nav-bar {
  background-color: #dd405e;
}
.wrapper >>> .swiper-pagination-bullet-active {
  background: #fff;
}
.my-bullet-active {
  background: #ffffff;
  background: rgba(255, 255, 255, 0.5) !important;
  /*opacity: 0.6;*/
}
.my-swiper-pagination-bullet {
  width: 15px;
  height: 15px;
  top: -15px;
  display: inline-block;
  border-radius: 100%;
  background: #000;
  margin-left: 15px;
  opacity: 0.3;
}
.wrapper {
  width: 100%;
  /* height: 310px; */
  height: auto;
  overflow: hidden;
  /* padding-bottom: 31.25%; */
  /* margin: 33px 0 20px -0; */
  top:10px;
}

.swiper-img {
  width: 100%;
  height:385px;
  border-radius:10px;
}
</style>